module.exports = __webpack_public_path__ + "img/3-1.f5ae4114.png";